import { render, staticRenderFns } from "./ResultTable.vue?vue&type=template&id=668a03b0&"
import script from "./ResultTable.vue?vue&type=script&lang=ts&"
export * from "./ResultTable.vue?vue&type=script&lang=ts&"
import style0 from "./ResultTable.vue?vue&type=style&index=0&id=668a03b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports